import { IfAbility } from '@efdigital/ll-addon-auth';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditCohortArrivals } from '@efdigital/ll-admin-v2/components/programs/edit-cohort-arrivals.gts';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortArrivalsRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/arrivals';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface ArrivalsSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortArrivalsRoute>;
    controller: unknown;
  };
}

const ProgramsProgramCohortArrivalsTemplate: TemplateOnlyComponent<ArrivalsSignature> =
  <template>
    <div class="container py-5">
      {{pageTitle "Arrivals"}}
      <IfAbility @ability="arrivals" @atLeast="viewer">
        <:if>
          <EditContext as |context|>
            <div class="row g-5">
              <div class="col-lg-8 col-xl-6 mx-auto">
                <EditCohortArrivals
                  @cohort={{@model.cohort}}
                  @arrival={{@model.arrival}}
                  @context={{context}}
                />
              </div>
            </div>
          </EditContext>
        </:if>
        <:else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Access Denied</h4>
            <p>You do not have permission to edit arrivals.</p>
            <p class="mb-0">Please contact your administrator if you believe you
              should have access.</p>
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>;

export default ProgramsProgramCohortArrivalsTemplate;
